import React from 'react'
import { Box, makeStyles, Theme, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { useTranslation } from 'react-i18next'
import { LegalEntityDirector } from '../../graphql'
import { isEqual } from 'lodash'

const useStyles = makeStyles((theme: Theme) => ({
  underline: {
    textDecoration: 'underline',
  },
  mobileTableRow: {
    fontFamily: 'Arial',
    fontSize: 14,
    marginBottom: theme.spacing(1),
    '&:not(:first-child)': {
      borderTop: '1px solid rgba(0,0,0,.1)',
    },
  },
  mobileDoubleItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileTableItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 57,
    padding: theme.spacing(1, 2),
    borderBottom: '1px solid rgba(0,0,0,.1)',
    lineHeight: '1.5rem',
  },
  mobileTableLabel: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: '#595959',
  },
  mail: {
    color: 'inherit',
  },
}))

const DirectorsMobileRowComponent: React.FC<{
  director: LegalEntityDirector
  handleDetails: (directorId: string | number) => () => void
  children?: React.ReactNode
}> = ({ handleDetails, director, children = null }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Box className={classes.mobileTableRow} onClick={handleDetails(director.id)}>
      <Box className={classes.mobileTableItem}>
        <Box className={classes.mobileTableLabel}>{t('name', 'Name')}</Box>
        <Typography className={classes.underline} noWrap>
          {director.individual?.fullName}
        </Typography>
      </Box>

      <Box className={classes.mobileTableItem}>
        <Grid container className={classes.mobileDoubleItem}>
          <Grid item xs={7}>
            <Box className={classes.mobileTableLabel}>{t('role', 'Role')}</Box>
            {t(director.role || '')}
          </Grid>
          <Grid item xs={5}>
            <Box className={classes.mobileTableLabel}>{t('rights', 'Rights')}</Box>
            <Box>{t(director.signingRight || '')}</Box>
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.mobileTableItem}>
        <Box className={classes.mobileTableLabel}>{t('email', 'Email')}</Box>
        <a
          className={classes.mail}
          href={`mailto:${director.individual?.email}`}
          onClick={(e) => e.stopPropagation()}
        >
          {director.individual?.email}
        </a>
      </Box>

      <Box className={classes.mobileTableItem}>
        <Grid container className={classes.mobileDoubleItem}>
          <Grid item xs={7}>
            <Box className={classes.mobileTableLabel}>{t('phoneNumber', 'Phone Number')}</Box>
            <a
              className={classes.mail}
              href={`tel:${director.individual?.phone}`}
              onClick={(e) => e.stopPropagation()}
            >
              {director.individual?.phone}
            </a>
          </Grid>
          <Grid item xs={5}>
            <Box className={classes.mobileTableLabel}>{t('actions', 'Actions')}</Box>
            {children}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export const DirectorsMobileRow = React.memo(DirectorsMobileRowComponent, isEqual)
